import {
  Avatar,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  Paper,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Clear } from "@material-ui/icons";
import { User } from "app-interfaces";
import React from "react";

import Icons from "../Utilities/Icons";

// TODO: test

const useStyles = makeStyles((theme) => ({
  heading: {
    height: 75,
    backgroundColor: "var(--text-primary)",
    color: "#ffffff",
    fontSize: 20,
    fontWeight: 500,
    padding: "25px 15px",
    "& svg": {
      float: "right",
      marginRight: 15,
    },
  },
  body: {
    overflow: "auto",
    "& .MuiAvatar-root": {
      float: "right",
      display: "inline-block",
    },
  },
  client: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(2),
  },
  clientText: {
    display: "flex",
    flexDirection: "column",
    paddingRight: theme.spacing(3),
  },
  clientName: {
    textTransform: "capitalize",
  },
  email: {},
}));

type Props = {
  show: boolean;
  onHide: () => void;
  clientsList: User.IUserClient[];
};

export default function ListClientsModal(props: Props) {
  const classes = useStyles();
  const { clientsList, show, onHide } = props;
  const { ic_user } = Icons;
  const mapClients = (client: User.IUserClient) => {
    return (
      <ListItem key={client.id} className="client-profile">
        <Paper className={classes.client}>
          <div className={classes.clientText}>
            <Typography variant="body1" noWrap className={classes.clientName}>
              {client.first_name} {client.last_name}
            </Typography>
            <Typography variant="body2" noWrap className={classes.email}>
              {client.email}
            </Typography>
          </div>
          <Avatar alt="profile" src={client.photo ? client.photo.small : ic_user} />
        </Paper>
      </ListItem>
    );
  };

  if (!show) return null;

  return (
    <Dialog open={show} onClose={onHide}>
      <DialogTitle className={classes.heading}>
        Session Clients <Clear onClick={onHide} />
      </DialogTitle>
      <DialogContent className={classes.body}>
        <List id="session-clients" style={{ cursor: "auto", backgroundColor: "var(--light)" }}>
          {(clientsList || []).map(mapClients)}
        </List>
      </DialogContent>
    </Dialog>
  );
}
